import { AuthActions, AuthActionTypes } from './actions';
import { initialAuthState, IAuthState } from './state';

export function authReducer(state = initialAuthState, action: AuthActions): IAuthState {
  switch (action.type) {
    case AuthActionTypes.AuthenticationSuccess: {
      return {
        ...state,
        isAuthenticated: true,
      };
    }

    case AuthActionTypes.Logout: {
      return {
        ...state,
        isAuthenticated: false,
      };
    }

    default:
      return state;
  }
}
